<script>
  import { checkbox } from 'vue-strap';
  import Importacao from './FormImportacao.vue';
  import Radio from '~componentes/Radio.vue';

  export default {
    components: { 
      checkbox, 
      Importacao,
      Radio,
    },
    props: {
      itensSolicitacaoImportacao: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        manterJustificativa: false,
        manterObservacao: false,
        manterLocalAlocado: false,
        configuracao: this.$storage.configuracao(),
        itemSolicitacao: this.camposItemSolicitacao(),
      }
    },
    methods: {
      validar() {
        const validacoes = [
          this.$validator.validateAll()
        ];

        if (!(this.itemSolicitacao.servico || this.itemSolicitacao.despesaCapital || this.itemSolicitacao.materialConsumo)){
          this.$swal(
            '',
            'É necessário selecionar o tipo de despesa. ',
            'info'
          );

          throw new Error('validacao');
        }

        validacoes.push(this.$refs.importacao.validar());

        Promise.all(validacoes)
          .then(valido => {
            if (valido.find(x => x === false) === undefined) {
              this.adicionar();
              this.$refs.importacao.resetarTipo();
            }
          });
      },
      async adicionar() {
        const copiaItem = Object.assign(this.itemSolicitacao);

        this.itensSolicitacaoImportacao.push(copiaItem);

        this.limparCamposItemSolicitacao();

        if (this.manterJustificativa) {
          this.$set(this.itemSolicitacao, 'objetivoImportacao', copiaItem.objetivoImportacao)
        }

        if (this.manterObservacao) {
          this.$set(this.itemSolicitacao, 'observacaoItemImportacao', copiaItem.observacaoItemImportacao)
        }

        this.$validator.reset();
        $('#tabs a[href="#tab-itens-solicitacao"]').tab('show');
      },
      limparCamposItemSolicitacao(completo = true) {
        const campos = this.camposItemSolicitacao();

        this.$set(this, 'itemSolicitacao', campos);
      },
      camposItemSolicitacao() {
        return {
          quantidade: '',
          descricao: '',
          valorEstimado: '',
          objetivoImportacao: '',
          observacaoItemImportacao: '',
          despesaCapital: '',
          servico: '',
          materialConsumo: '',
          codigoItem: '',
          ncmhsCode: '',
          nomeFabricante: '',
          paisProcedencia: '',
          unidade: '',
          desconto: '',
          vat: '',
        }
      },
    },
    computed: {
      objetivoImportacaoContador() {
        let quantidadeCaracteres = this.itemSolicitacao.objetivoImportacao ? 
            this.itemSolicitacao.objetivoImportacao.length : 0;

        return 500 - quantidadeCaracteres;
      },
    },
    watch: {
    }
  }
</script>

<template>
  <div>
    <importacao 
        ref="importacao" 
        :item-solicitacao.sync="itemSolicitacao"
        :itens-solicitacao-importacao.sync="itensSolicitacaoImportacao"
        :manter-observacao.sync="manterObservacao">
    </importacao>

    <div>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <div class="checkbox">
              <checkbox v-model="manterJustificativa" value="1" type="primary">
                Manter objetivo da compra (caso esta solicitação 
                demandar outros itens com a mesma justificativa)
              </checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group" :class="{'has-error': errors.has('justificativaCompra'), 'required': configuracao.justificativaImportacaoObrigatoria}">
            <label class="control-label" for="objetivo-compra">Objetivo/Justificativa da importação ({{ objetivoImportacaoContador }})</label>

            <textarea
              class="form-control" 
              id="objetivo-compra" 
              v-model="itemSolicitacao.objetivoImportacao"
              data-vv-name="justificativaCompra"
              data-vv-as="Objetivo/Justificativa da importação"
              maxlength="500"
              v-validate="`${configuracao.justificativaImportacaoObrigatoria ? 'required' : ''}`">
            </textarea>

            <p class="text-danger" v-show="errors.has('justificativaCompra')">{{ errors.first('justificativaCompra') }}</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button type="button" class="btn btn-success" @click="validar">
              <i class="fa fa-plus"></i> 
              Adicionar item
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao/componentes/compartilhado/FormAdicionarItem.vue